import { AuthError as SupabaseAuthError } from '@supabase/auth-js';
import { PostgrestError } from '@supabase/postgrest-js';
import {
	FunctionsFetchError,
	FunctionsHttpError,
	FunctionsRelayError,
} from '@supabase/supabase-js';

import {
	AppError,
	AuthError,
	HttpError,
	NetworkError,
	NotFoundError,
	ServerError,
	UnknownError,
} from './app-error';

export const throwAsSupabaseError = (error: unknown): never => {
	if (error instanceof AppError) throw error;

	if (error instanceof FunctionsHttpError) {
		const status = (error.context as Response)?.status ?? 0;
		if (status === 401) throw new AuthError(error.message);
		if (status === 404) throw new NotFoundError(error.message);
		if (status >= 500) throw new ServerError(status, error.message);
		throw new HttpError(status, error.message);
	}

	if (
		error instanceof FunctionsRelayError ||
		error instanceof FunctionsFetchError
	) {
		throw new NetworkError();
	}

	if (error instanceof SupabaseAuthError) {
		if (error.status === 401) throw new AuthError(error.message);
		if (error.status !== undefined && error.status >= 500)
			throw new ServerError(error.status, error.message);
		throw new UnknownError('인증 오류가 발생했어요');
	}

	if (error instanceof PostgrestError) {
		throw new ServerError(500, error.message);
	}

	throw new UnknownError();
};
